import { getUrlParams, getSignedParams, getPhpNow, getUdid, getUUids } from '@/utils';
import { getConfig, init, login, pay, role, online, openRebate, openPreRebate, pushPopImg, getOrderPayStatus} from '@/api/mixServer';
import { mixServerConfig } from '@/config';
import server, { sendMsg } from './index';
import statis from './statis';
import store from '@/store';
import { Dialog } from 'vant';
import channelServer from './channelServer';
import { notificationPostmessager } from '../features/notificationPostmessager';

const mixServer = {
  appid: getUrlParams('appid'),
  // 配置接口返回结果
  configData: {},
  // 初始化返回结果
  initData: {
    // 在线时长上报间隔
    alive: 20
  },
  // 是否开启防沉迷
  isAntiAddiction: 1,
  // 玩家实名状态
  force_cert_status: '',
  // 过期时间
  expire_time: '',
  // 当前时间戳
  currentTime: '',
  // 强制玩家下线时间
  expireTime: '',
  // 应用ID
  ln_appid: '',
  // 融合SDK的秘钥
  app_key: '',
  // 游戏链接
  game_link: '',
  // 融合access_token
  access_token: '',
  login_id: '',
  fu_uid: '',
  ouid: '',
  mixAccount: '',
  mixToken: '',
  loginTimer: null,
  record_number: '',
  record_number_url: '',
  getConfig() {
    const params = {
      appid: this.appid,
      notch_height: getUrlParams('notch_height') || '0',
      bottom_height: getUrlParams('bottom_height') || '0',
      sys_ver: getUrlParams('sys_ver') || '',
      uuid: getUUids() || '',
      idfa: getUrlParams('idfa') || '',
      package_ver: getUrlParams('ver') || '',
      time: getPhpNow()
    };
    const signedParams = getSignedParams(mixServerConfig.app_key, params);
    return getConfig(signedParams).then(async res => {
      const { data = {} } = res;
      this.configData = data;
      this.ln_appid = data.ln_appid || '';
      const app_key = data.app_key || '';
      this.app_key = app_key;
      mixServerConfig.api_app_key = app_key;
      this.game_link = data.game_link || '';
      document.title = data.game_title || '名酱三国';
      if (data.is_open_health == 1) {
        store.commit('SET_HEALTH', true);
        store.commit('SET_GAMEDIST', data.direction);
        await this.delayHealth(2000);
        store.commit('SET_HEALTH', false);
      }
      return res;
    });
  },
  delayHealth(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  init() {
    // 获取浏览器唯一标识
    return new Promise((resolve, reject) => {
      getUdid()
        .then(udid => {
          const params = {
            appid: this.appid,
            time: getPhpNow(),
            ver: server.ver,
            udid: udid,
            uuid: udid,
            caid: getUrlParams('caid') || '',
            adver_ext: getUrlParams('adver_ext') || '',
            ...server.shareParams
          };
          // console.log(this.app_key)
          const signedParams = getSignedParams(this.app_key, params);
          init(signedParams)
            .then(res => {
              const { data = {} } = res;
              this.initData = data;
              const access_token = data.access_token || '';
              this.access_token = access_token;
              mixServerConfig.access_token = access_token;
              this.isAntiAddiction = data.is_anti_addiction; // 是否开启防沉迷
              this.record_number = data.record_number;
              this.record_number_url = data.record_number_url;
              store.commit('SET_ROLE_INTERVAL', data.role_level_interval * 1000 || 1000);
              store.commit('SET_BUTTON_INTERVAL', data.button_interval || 500);
              // 存储过审状态用于未过审的情况下登录界面增加删除账号功能
              // 20233.3.10国外ip显示删除账号（暂时处理63754）
              let arrIPs = ['中国', '香港', '澳门', '台湾', '0', '', ''];
              if (data.ip2region) {
                if (!arrIPs.includes(data.ip2region.country) && getUrlParams('appid') == '63754') {
                  store.commit('SET_IP', true);
                  // data.is_vertify = 0;
                }
              }
              // 苹果ip屏蔽
              if (data.is_apple_ip && data.is_apple_ip == 1 && getUrlParams('appid') == '63754') {
                // store.commit('SET_IP', true)
                data.is_vertify = 0;
              }

              console.log(data.is_vertify);
              localStorage.setItem('ln_is_vertify', data.is_vertify);
              // 2021.12.9个人信息法存储游戏声明更新版本
              if (localStorage.getItem('ln_user_ver') && localStorage.getItem('ln_user_ver') != data.protocal_version) {
                // 上一次有同意过才提示更新版本
                if (localStorage.getItem('ln_agree') == 2) {
                  store.commit('SHOW', {
                    name: 'GameState',
                    params: { isVer: true, verUrl: data.protocal_update, status: 1 }
                  });
                  localStorage.setItem('ln_user_ver', data.protocal_version);
                  store.commit('SET_GAMESTATEVER', data.protocal_update);
                  return;
                } else {
                  store.commit('SHOW', {
                    name: 'GameState',
                    params: { isVer: false }
                  });
                }
              } else {
                // 如果弹了更新后的版本，再点拒绝，下次进入还会继续弹更新后的版本
                if (localStorage.getItem('ln_status') == 1) {
                  console.log(data.protocal_update);
                  store.commit('SHOW', {
                    name: 'GameState',
                    params: { isVer: true, verUrl: data.protocal_update, status: 1 }
                  });
                  return;
                }
                localStorage.setItem('ln_user_ver', data.protocal_version);
              }
              console.log(this.game_link, '游戏链接');
              if (
                this.game_link.indexOf('huanyuantech.com') > -1 ||
                this.game_link.indexOf('youyantech.com') > -1
              ) {
                store.commit('SET_ISHOVER', false);
              } else {
                store.commit('SET_ISHOVER', true);
              }
              // 传给oc hackjs解决ipad云闪付
              try {
                let hackjs = [data.hackjs];
                window.webkit.messageHandlers['hackExt'].postMessage({ params: hackjs });
              } catch (error) {
                console.log(error);
              }

              // 处理广点通上报开关，gdt_source_id有值表示需要上报广点通
              if (data.gdt_source_id) {
                // 广点通广告初始化
                store.commit('SET_GDT_SWITCH', true);
                try {
                  // gdt('init', data.gdt_source_id);
                  // gdt('track', 'START_APP');
                  window.webkit.messageHandlers['gdtInitParams'].postMessage({ params: [data.gdt_source_id, data.gdt_secret_key] });
                } catch (error) {
                  console.log(error)
                }
              }
              resolve(res);
              statis.clientEvent({ event: 'fusion_sdk_init_succ', data: { level: 0, power: 0 } });
               //初始化完成传给ios广告的appid
               try {
                window.webkit.messageHandlers['getIosAdAppid'].postMessage({ params: ['5774282', 1] });
               } catch (error) {
                 console.log(error)
               }
            })
            .catch(error => {
              console.error('融合SDK初始化失败:', error);
              reject(error);
            });
        })
        .catch(error => {
          console.error('获取浏览器唯一标识错误:', error);
          reject(error);
        });
    });
  },
  login(params) {
    let onlieParams = { roleid: '', server_id: '', ver: getUrlParams('ver') };
    // 是否开启红包功能参数（227测试）
    const rebateAct = {
      ln_uid: '5298824078',
      server_no: '124564',
      role_id: '12054',
      level: 100,
      role_name: '测试红包',
      server_name: '测试区服'
    };
    // 切换账号重新登录初始化红包弹窗状态
    store.commit('SET_RABTOPEN', false);
    params.caid = getUrlParams('caid') || '';
    params.adver_ext = getUrlParams('adver_ext') || '';
    // this.getRebateAct(rebateAct);
    return new Promise((resolve, reject) => {
      login(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 每次登录成功需要清掉上一次定时器（在线时长）
          clearInterval(server.timer);
          // 每次登录生成新的login_id
          const randDateTimeStr = String(new Date().valueOf()) + 'RD' + Math.floor(Math.random() * 10000000 + 1);
          this.login_id = randDateTimeStr;
          this.fu_uid = data.fu_uid;
          this.ouid = data.ouid;
          // console.log(this.login_id)
          this.mixAccount = data.account;
          this.mixToken = data.login_token;

          localStorage.setItem('lnUserAccount', store.state.curr_user_info.name);
          localStorage.setItem('lnUserPass', store.state.curr_user_info.pwd);
          localStorage.setItem('agreeProt', true);
          // if (store.state.isCertName) {
            if (localStorage.getItem('cp_storage')) {
              // console.log('***11111', localStorage.getItem('cp_storage'))
              sendMsg('LOGIN_SUCCESS', {
                account: data.account,
                uid: data.union_uid,
                token: data.login_token,
                ip_info: data.ip_info,
                cp_storage: localStorage.getItem('cp_storage'),
                client_type: getUrlParams('client_type') || '',
                record_number: this.record_number,
                record_number_url: this.record_number_url,
                fu_uid: data.fu_uid,
                appid: getUrlParams('appid') || ''
              });
            } else {
              sendMsg('LOGIN_SUCCESS', {
                account: data.account,
                uid: data.union_uid,
                token: data.login_token,
                ip_info: data.ip_info,
                cp_storage: '',
                client_type: getUrlParams('client_type') || '',
                record_number: this.record_number,
                record_number_url: this.record_number_url,
                fu_uid: data.fu_uid,
                appid: getUrlParams('appid') || ''
              });
            }
            console.log(getUrlParams('client_type'));
          // }
          // 统计sdk融合登录上报
          let fuLoginParams = {
            fu_uid: data.fu_uid,
            ln_uid: channelServer.ln_uid,
            ouid: data.ouid,
            platform: parseInt(data.app_type),
            is_reg: data.is_new_user,
            reg_time: parseInt(data.reg_time)
          };
          statis.fusion_login([fuLoginParams]);

          resolve(data);
        } else {
          Dialog({ message: msg });
        }
        // this.onlineCommit(onlieParams); // 融合登录进行上报时长
      });
    });
  },
  //  当游戏id为'88'时在融合登录进行在线时长上报(包括首次和后续)
  onlineCommit(onlineParams) {
    // if (getUrlParams('game_id') != 88) return; // 当游戏id为88时不执行上报时长逻辑
    // 首次上报
    this.online({ ...onlineParams, seconds: 0, type: 1 }).then(data => {
      // 弹出实名登记
      const toCert = data => {
        store.commit('SHOW', {
          name: 'Certification',
          // 在线时长弹出，一定是强制
          params: { ...data, isForceCert: true, is_close: false }
        });
      };
      // 需要弹出实名认证
      // if (this.isAntiAddiction == 1) {
      //   if (data.is_allow_online == 0) {
      //     if (store.state.user.cert_type != 1) {
      //       // 如果登录时没有弹出实名认证，则在这里弹出
      //       toCert(data);
      //     }
      //     // 如果不允许在线，强制重启游戏,不后续上报
      //     this.reloadGameFrame();
      //     return;
      //   }
      // }
      this.expire_time = data.expire_time;
      if (this.isAntiAddiction == 1) {
        if (data.is_allow_online == 0) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 1) {
            // 强制退出游戏的弹窗不可关闭
            Dialog.alert({
              title: '',
              message: data.cert_msg,
              theme: 'round-button'
            }).then(() => {
              this.reloadGameFrame(); // 退出游戏
            });
            clearInterval(this.timer);
            return;
          } else if (data.type == 2) {
            // 实名认证弹窗不可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: false }
            });
            clearInterval(this.timer);
            return;
          }
          // 如果不允许在线，强制重启游戏,不后续上报
          // toCert(data);
          // this.reloadGameFrame();
          // clearInterval(this.timer);
        } else if (data.is_allow_online == 1) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 2) {
            // 弹窗实名认证弹窗，可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: true }
            });
          }
        }
      }
      // 后续上报
      const alive = mixServer.initData.alive;
      if (alive) {
        this.timer = setInterval(() => {
          this.online({ ...onlineParams, seconds: alive, type: 2 }).then(data => {
            console.log(data);
            if (this.isAntiAddiction == 1) {
              if (data.is_allow_online == 0) {
                if (data.type == 0) {
                  store.commit('CLOSE');
                } else if (data.type == 1) {
                  // 强制退出游戏的弹窗不可关闭
                  Dialog.alert({
                    title: '',
                    message: data.cert_msg,
                    theme: 'round-button'
                  }).then(() => {
                    this.reloadGameFrame(); // 退出游戏
                  });
                  clearInterval(this.timer);
                } else if (data.type == 2) {
                  // 实名认证弹窗不可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: false }
                  });
                  clearInterval(this.timer);
                }
                // 如果不允许在线，强制重启游戏,不后续上报
                // toCert(data);
                // this.reloadGameFrame();
                // clearInterval(this.timer);
              } else if (data.is_allow_online == 1) {
                if (data.type == 0) {
                  store.commit('CLOSE');
                } else if (data.type == 2) {
                  // 弹窗实名认证弹窗，可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: true }
                  });
                }
              }
            }
          });
        }, +mixServer.initData.alive * 1000);
      }
    });
  },
  pay(params) {
    return new Promise((resolve, reject) => {
      pay(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 支付成功
          sendMsg('PAY_SUCCESS', { message: msg });
          resolve(data);
        } else if (ret == 81023) {
          // 实名验证
          store.commit('SHOW', {
            name: 'Certification',
            params: { isPay: true, payMsg: msg, payParams: params, is_close: true, expire_time: server.expire_time }
          });
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  role(params) {
    params.adver_ext = getUrlParams('adver_ext') || '';
    return new Promise((resolve, reject) => {
      role(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 角色上报成功,不需反馈给游戏端
          // sendMsg('ROLE_REPORT_SUCCESS');
          resolve(data);
        } else {
          console.error('角色上报失败:' + msg);
        }
      });
    });
  },
  online(params) {
    return new Promise((resolve, reject) => {
      online(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 在线时长上报成功,不需反馈给游戏端
          resolve(data);
        } else {
          console.error('在线时长上报失败:' + msg);
        }
      });
    });
  },
  getRebate(params) {
    return new Promise((resolve, reject) => {
      openRebate(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          console.error('获取红包开启失败:' + msg);
        }
      });
    });
  },
  // 订单状态轮询
  getOrderPayStatus(params) {
    return new Promise((resolve, reject) => {
      getOrderPayStatus(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          console.error(msg);
        }
      });
    })
  },
  // 是否开启红包（227测试）
  getRebateAct(params) {
    this.getRebate(params).then(data => {
      if (data.open == 1) {
        store.commit('SET_OPEN', true);
        store.commit('SET_REBATEURL', `${data.url}?tk=${data.tk}&access_token=${mixServerConfig.access_token}&sdk=h5`);
        // store.commit('SET_REBATEURL', url);
      } else {
        store.commit('SET_OPEN', false);
      }
    });
  },
  // 红包前置自动展示
  getPreRebate(params) {
    return new Promise((resolve, reject) => {
      openPreRebate(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          console.error('获取红包开启失败:' + msg);
        }
      });
    });
  }
};

export default mixServer;
